<div class="row">
	<div class="col-12">
		<h2>Comments</h2>
	</div>

	<!-- Add Comment Form -->
	<div class="col-12 col-md-7 col-lg-6">
		<mat-card class="mt-3">
			<mat-card-header>
				<mat-card-title>Add a New Comment</mat-card-title>
			</mat-card-header>

			<mat-card-content>
				<form #commentForm="ngForm" novalidate>
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>New Comment</mat-label>

						<!-- You can replace this textarea with a Material WYSIWYG later -->
						<textarea matInput id="commentBody" name="commentBody" [(ngModel)]="newComment.BODY"
							#commentBody="ngModel" required placeholder="Enter your comment" rows="5"></textarea>

						<mat-error *ngIf="commentForm.submitted && commentBody.invalid">
							Comment Body Required
						</mat-error>
					</mat-form-field>

					<div class="text-end mt-3">
						<button mat-raised-button color="primary" type="button"
							[disabled]="!newComment?.BODY || newComment?.BODY?.length === 0"
							(click)="addComment(commentForm.valid!)">
							<mat-icon>add_comment</mat-icon>
							Add Comment
						</button>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
	</div>


	<!-- Comments List -->
	<div class="col-12 col-md-5 col-lg-6 mt-3" *ngIf="!isLoading && node?.NODE_COMMENTS?.length > 0">
		<ng-container
			*ngFor="let comment of node.NODE_COMMENTS | orderBy: 'CREATED_DATE' : '' | slice: 0 : commentsLimit">
			<mat-card class="mb-3" [ngClass]="{
        'border-success': userOwnsComment(comment),
        'border-info': !userOwnsComment(comment)
      }">
				<mat-card-header>
					<div mat-card-avatar class="comment-avatar">
						<mat-icon>person</mat-icon>
					</div>
					<mat-card-title>
						{{ comment.LOGIN_DETAILS.PERSON.FIRST_NAME }}
						{{ comment.LOGIN_DETAILS.PERSON.LAST_NAME }}
					</mat-card-title>
					<mat-card-subtitle>
						({{ comment.LOGIN_DETAILS.USER_ID }})
					</mat-card-subtitle>
				</mat-card-header>

				<mat-divider></mat-divider>

				<mat-card-content class="mt-2 margin-vertical-md">
					<!-- View Mode -->
					<div *ngIf="!isEditingComment(comment)" class="multiline-tooltip">
						{{comment.BODY | htmlToString}}
					</div>

					<!-- Edit Mode -->
					<form *ngIf="isEditingComment(comment)" #editCommentForm="ngForm" novalidate>
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Edit Comment</mat-label>
							<textarea matInput name="editCommentBody" [(ngModel)]="editingThisComment.BODY"
								#editBody="ngModel" required></textarea>
							<mat-error *ngIf="editCommentForm.submitted && editBody.invalid">
								Comment Body Required
							</mat-error>
						</mat-form-field>

						<div class="text-end mt-2">
							<button mat-stroked-button color="warn" (click)="cancelEdit()">
								<mat-icon>cancel</mat-icon> Cancel
							</button>
							<button mat-raised-button color="primary" (click)="saveComment(editCommentForm.valid!)"
								class="ms-2" [disabled]="editingThisComment?.BODY?.length === 0">
								<mat-icon>check</mat-icon> Save
							</button>
						</div>
					</form>
				</mat-card-content>

				<mat-divider></mat-divider>

				<mat-card-actions>
					<div class="d-flex justify-content-between align-items-center w-100">
						<div>
							<ng-container *ngIf="userOwnsComment(comment)">
								<button mat-icon-button color="accent" (click)="editComment(comment)" matTooltip="Edit">
									<mat-icon>edit</mat-icon>
								</button>

								<confirm-popover [buttonType]="'icon'" [icon]="'delete'" [color]="'warn'"
									[popoverMsg]="'Delete Confirmation'" [popoverConfirmText]="'Delete'"
									[popoverConfirmColor]="'warn'" [tooltip]="'Delete'"
									(onConfirm)="deleteComment(comment)"></confirm-popover>
							</ng-container>
						</div>

						<div class="text-end">
							<small class="d-block">
								Created:
								{{ comment.CREATED_DATE | cleanDate | date: 'short' }}
							</small>
							<small class="d-block" *ngIf="comment.MODIFIED_DATE">
								Edited:
								{{ comment.MODIFIED_DATE | cleanDate | date: 'short' }}
							</small>
						</div>
					</div>
				</mat-card-actions>
			</mat-card>
		</ng-container>
	</div>

</div>

<!-- Show all / Collapse buttons -->
<div class="row mt-3">
	<div class="col-12 col-md-4 offset-md-4">
		<button mat-raised-button class="w-100"
			*ngIf="!isLoading && commentsLimit < 1000000000 && node.NODE_COMMENTS && node.NODE_COMMENTS.length > 5"
			(click)="commentsLimit = 1000000000">
			Show all
		</button>

		<button mat-raised-button class="w-100"
			*ngIf="!isLoading && commentsLimit >= 1000000000 && node.NODE_COMMENTS && node.NODE_COMMENTS.length > 5"
			(click)="commentsLimit = 5">
			Collapse
		</button>
	</div>
</div>